var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeleteTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00141 19.5H21.7514C22.1614 19.5 22.5014 19.16 22.5014 18.75V5.25C22.5014 4.84 22.1614 4.5 21.7514 4.5H9.00141C8.80141 4.5 8.61141 4.58 8.47141 4.72L1.72141 11.47C1.43141 11.76 1.43141 12.24 1.72141 12.53L8.47141 19.28C8.61141 19.42 8.80141 19.5 9.00141 19.5ZM21.0014 18H9.31141L3.31141 12L9.31141 6H21.0014V18ZM18.7514 8.56L15.3114 12L18.7514 15.44L17.6914 16.5L14.2514 13.06L10.8114 16.5L9.75141 15.44L13.1914 12L9.75141 8.56L10.8114 7.5L14.2514 10.94L17.6914 7.5L18.7514 8.56Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteTicket);
export default __webpack_public_path__ + "static/media/ic-delete-ticket.d2e157ed1b240bc0bf7d96582e7a2c69.svg";
export { ForwardRef as ReactComponent };